import React from 'react';

function Overlay() {
  return (<><div className='overlay'/><div className='bgndpicture'/></>);
}

export default Overlay;
